import opDevCall from '@/mixins/op-dev-call.js';

const CACHE_TTL_MS = 86400000;
const CACHE = {};

const USER_ORG_CACHE_TTL_MS = 900000;
const USER_ORG_CACHE = {};

const orgSkin = {
  mixins: [ opDevCall ],
  methods: {
    async getUserOrgSkin(useCache=true) {
      if (!this.global.profile?.org)
        return null;
      const key = this.globalUserId;
      if (!useCache || !USER_ORG_CACHE[key] || ((new Date()) - USER_ORG_CACHE[key].t > USER_ORG_CACHE_TTL_MS))
        USER_ORG_CACHE[key] = { t: new Date(), p: this.$call('get-user-org') };
      const org = await USER_ORG_CACHE[key].p;
      if (!org)
        return null;
      CACHE[org.id] = { t: new Date(), p: new Promise(r => r(org.skin)) };
      return org.skin;
    },

    async getOrgSkin(org_id, useCache=true) {
      if (!org_id)
        return null;
      if (!useCache || !CACHE[org_id] || ((new Date()) - CACHE[org_id].t > CACHE_TTL_MS))
        CACHE[org_id] = { t: new Date(), p: this.$call('get-org-skin', { org_id }) };
      return await CACHE[org_id].p;
    },

    clearOrgSkinCache() {
      for (const key of Object.keys(CACHE))
        delete CACHE[key];
    }
  }
};

export { orgSkin };
